"use client";

import { useEffect } from "react";
import { useBusinessStore } from "@/store/business";
import { useLocaleStore } from "@/store/locale";

interface StoreInitializerProps {
  business: any;
  children?: React.ReactNode;
}

/**
 * StoreInitializer - Initializes global stores with business data
 * Used on pages that don't use DynamicThemeRenderer (e.g., product pages)
 */
export function StoreInitializer({ business, children }: StoreInitializerProps) {
  const updateBusinessConfig = useBusinessStore((state) => state.updateBusinessConfig);
  const initializeLocale = useLocaleStore((state) => state.initializeFromBusiness);

  // Initialize stores when business data is available
  useEffect(() => {
    if (business) {
      // Update business store
      updateBusinessConfig(business);

      // Initialize locale store (fetches currencies from API)
      initializeLocale(business);

      console.log("✅ StoreInitializer initialized stores with business:", {
        businessId: business.id,
        locales: business.locales,
        currency: business.currency,
      });
    }
  }, [business, updateBusinessConfig, initializeLocale]);

  return children;
}
